var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4906 22.7801L21.1177 24.2139L44.8378 18.7961C45.1633 20.0858 45.3845 21.417 45.4906 22.7801Z",
    fill: "#FED506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5653 24.6811C45.5653 25.3511 45.5381 26.0146 45.4835 26.6704L21.1177 24.2133L45.4906 22.7795C45.5404 23.4069 45.5653 24.0407 45.5653 24.6811Z",
    fill: "#32BE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8378 18.7923L21.1177 24.2101L43.5357 15.0034C44.0711 16.2172 44.5087 17.4831 44.8378 18.7923Z",
    fill: "#FDAB2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8046 30.6973C44.45 32.0711 43.9768 33.397 43.3958 34.6635L21.1177 24.2117L44.8046 30.6973Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4835 26.6688C45.3709 28.048 45.1414 29.394 44.8046 30.6973L21.1177 24.2117L45.4835 26.6688Z",
    fill: "#28B2E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0024 25.2098L42.3742 36.5196C41.3039 38.404 39.9858 40.1288 38.4643 41.6503C34.1388 45.9759 28.1696 48.6577 21.5737 48.6791C21.547 48.6797 21.5203 48.6797 21.4937 48.6797H17.6958V39.243H22.3647C24.9167 39.243 26.9849 37.1748 26.9849 34.6228V34.4443C26.9849 31.8923 24.9167 29.8241 22.3647 29.8241H15.2446V48.6797H0.824219V0.679688H17.5215V10.2302H15.2446V19.6492H22.3647C24.9167 19.6492 26.9849 17.581 26.9849 15.0289V14.8505C26.9849 12.2984 24.9167 10.2302 22.3647 10.2302H19.92V0.679688H21.4937C30.5663 0.679688 38.4631 5.71378 42.5432 13.1416L20.0273 23.6426C19.3685 23.9498 19.3537 24.8813 20.0024 25.2098Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5761 48.679L21.4961 48.6795C21.5228 48.6795 21.5495 48.6795 21.5761 48.679Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.519e688ab23acaae5f31f678e206b57d.svg";
export { ForwardRef as ReactComponent };